import { User } from "./user";

export class UserDetail {
    user?: User;
    isCreationMode?: boolean;
    isEditMode?: boolean;
    isReadOnlyMode?: boolean;
    constructor(userDetail?: UserDetail) {
        this.user = userDetail?.user;
        this.isCreationMode = userDetail?.isCreationMode || false;
        this.isEditMode = userDetail?.isEditMode || false;
        this.isReadOnlyMode = userDetail?.isReadOnlyMode || false;
    }
}
